const call = (type, payload) =>
  fetch('/api/send-email.php', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ type, ...payload }),
  }).then(r => r.json());

// Internal alert → akdmetech.support@akdmetech.com (plain text is fine)
export const notifyInternal = (subject, text, replyTo) =>
  call('notify', { subject, text, replyTo });

// Styled email → customer's inbox  ({ html, text } from emailTemplates)
export const notifyCustomer = (to, subject, { html, text }) =>
  call('customer', { to, subject, html, text });
